export const Area = () => (
  <section
    id="omrade"
    aria-labelledby="omrade-title"
    className="overflow-hidden bg-ink py-16 text-paper md:py-20 lg:py-24"
    data-testid="omrade-section"
  >
    <div className="container-site grid gap-10 lg:grid-cols-12 lg:items-center">
      <div className="reveal lg:col-span-5">
        <p className="text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-[#8DC7F0]">Område</p>
        <h2 id="omrade-title" className="mt-5 max-w-[520px] font-display text-4xl leading-[0.98] text-paper sm:text-5xl lg:text-[4rem]">
          Bygguppdrag nära Folkarebygden
        </h2>
        <p className="mt-8 max-w-[540px] text-lg leading-relaxed text-paper/90">
          Folkare Bygg arbetar främst i Avesta och Hedemora kommuner. Uppdrag längre bort, till exempel i Stockholm, förekommer ibland.
        </p>
      </div>

      <div className="reveal lg:col-span-6 lg:col-start-7">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-paper/65">Även närliggande områden</p>
        <ul className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {["Sala", "Norberg", "Hofors", "Heby", "Säter", "Sandviken"].map((place) => (
            <li key={place} className="border border-paper/20 px-4 py-4 font-display text-xl text-paper sm:text-2xl">
              {place}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
